import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "warning"];

  updateLink() {
    // Ignore prompt
    if (event.target.value) {
      // Update link text
      this.linkTarget.innerHTML = `Être rattaché à ${event.target.selectedOptions[0].text}`;

      // Update path with selected item id
      const id = event.target.value;
      const path = this.linkTarget.getAttribute("href");
      const regex = /(.*\/)(\d*)(\/merge)/;
      this.linkTarget.setAttribute("href", path.replace(regex, `$1${id}$3`));
    }
  }

  closeWarning() {
    this.warningTarget.remove();
  }
}
